const Content = resolve => require(['../components/Content.vue'], resolve);
const Line = resolve => require(['../components/Line.vue'], resolve);
const Category = resolve => require(['../components/Category.vue'], resolve);
const Subcategory = resolve => require(['../components/Subcategory.vue'], resolve);
const Type = resolve => require(['../components/Type.vue'], resolve);

// SHOP
const Login = resolve => require(['../components/Login.vue'], resolve);
const Shop = resolve => require(['../components/Shop.vue'], resolve);
const ShoppingCart = resolve => require(['../components/ShoppingCart.vue'], resolve);

// USER
const User = resolve => require(['../components/User.vue'], resolve);
const UserDashboard = resolve => require(['../components/UserDashboard.vue'], resolve);
const UserFavlists = resolve => require(['../components/UserFavlists.vue'], resolve);
const UserOrders = resolve => require(['../components/UserOrders.vue'], resolve);
const UserAccount = resolve => require(['../components/UserAccount.vue'], resolve);
const UserChangePassword = resolve => require(['../components/UserChangePassword.vue'], resolve);
const UserHelp = resolve => require(['../components/UserHelp.vue'], resolve);

// TMP
const Tmp = resolve => require(['../components/Tmp.vue'], resolve);

const preRoute = 'Catálogo de Productos - Grupo BIV'
const preRoute2 = ' - Grupo BIV'

export const routes = [
	//{ path : '/:language/p', name: 'content', component: Shop, 
	{ path : '/p', name: 'content', component: Shop, 
		meta: { breadcrumb: [ { title: preRoute, routeName: "" } ] },
		children:[
			{ path : ':lin', name: 'line', component: Line, 
				meta: { breadcrumb: [ { title: preRoute, routeName: "" } ] } 
			},
			{ path : ':lin/:ctg', name: 'category', component: Category, 
				meta: { breadcrumb: [ { title: preRoute, routeName: "" } ] } 
			},
			{ path : ':lin/:ctg/:sct', name: 'subcategory', component: Subcategory, 
				meta: { breadcrumb: [ { title: preRoute, routeName: "" } ] } 
			},
			{ path : ':lin/:ctg/:sct/:typ', name: 'type', component: Type, 
				meta: { breadcrumb: [ { title: preRoute, routeName: "" } ] } 
			},
			{ path : ':lin/:ctg/:sct/:typ/:ref', name: 'reference', component: Content, 
				meta: { breadcrumb: [ { title: preRoute, routeName: "" } ] } 
			},
		]
	},
	
	{ path : '/tmp', name: 'tmp', component: Tmp, 
		meta: { breadcrumb: [ { title: "Tmp", routeName: "" } ] } 
	},

	{ path : '/login', name: 'login', component: Login, 
		meta: { breadcrumb: [ { title: "Login" + preRoute2, routeName: "" } ] } 
	},

	{ path : '/shopping-cart', name: 'shopping-cart', component: ShoppingCart, 
		meta: { breadcrumb: [ { title: "Carrito" + preRoute2, routeName: "" } ] } 
	},

	{ path : '/user', name: 'user', component: User, 
		meta: { breadcrumb: [ { title: "Usuario" + preRoute2, routeName: "" } ] },
		children: [
			{
				path : 'dashboard', name: 'user-dashboard', component: UserDashboard, 
				meta: { breadcrumb: [ { title: "Dashboard" + preRoute2, routeName: "" } ] }
			},
			{
				path : 'favlists', name: 'user-favlists', component: UserFavlists, 
				meta: { breadcrumb: [ { title: "Listas de favoritos" + preRoute2, routeName: "" } ] }
			},
			{
				path : 'orders', name: 'user-orders', component: UserOrders, 
				meta: { breadcrumb: [ { title: "Pedidos" + preRoute2, routeName: "" } ] }
			},
			{
				path: 'account', name: 'user-account', component: UserAccount, 
				meta: { breadcrumb: [ { title: "Perfil de Usuario" + preRoute2, routeName: "" } ] }
			},
			{
				path: 'password', name: 'user-change-password', component: UserChangePassword, 
				meta: { breadcrumb: [ { title: "Cambiar Contraseña" + preRoute2, routeName: "" } ] }
			},
			{
				path: 'help', name: 'user-help', component: UserHelp, 
				meta: { breadcrumb: [ { title: "Ayuda" + preRoute2, routeName: "" } ] }
			}  	
		]
	},

	{ path : '*',  redirect: to => ({ 
																		name: 'line', 
																		params: { 
																			 
																			lin: '1-AGUA' 
																		} 
																	}) 
	}

];

